import {
  INSTANCE_VEHICLE_TYPE_ALL,
  URLS,
  SELECTED_CITY_CONFIG,
} from '../constants';

const { REACT_APP_OPEN_DATA_X_API_KEY: openDataXApiKey } = process.env;
const { VEHICLE_TYPE: instanceVehicleTypes, AGENCY_ID: agencyId } =
  SELECTED_CITY_CONFIG;

const {
  GTFS_URL,
  GTFS_ROUTES_PATH,
  GTFS_TRIPS_PATH,
  GTFS_SHAPES_PATH,
  GTFS_STOPS_PATH,
  GTFS_STOP_TIMES_PATH,
  GTFS_VEHICLES_PATH,
} = URLS;

const gtfsHeaders = {
  'X-API-KEY': openDataXApiKey,
  'x-Agency-Id': agencyId,
  'Content-Type': 'application/json',
};

const filterRoutesByVehicleTypes = (routes, vehicleTypes) =>
  routes.filter((route) => vehicleTypes.includes(String(route.route_type)));

export const fetchAllData = async () => {
  try {
    const requestUrls = [
      `${GTFS_URL}${GTFS_ROUTES_PATH}`,
      `${GTFS_URL}${GTFS_TRIPS_PATH}`,
      `${GTFS_URL}${GTFS_STOPS_PATH}`,
      `${GTFS_URL}${GTFS_STOP_TIMES_PATH}`,
    ];

    const requestPromises = requestUrls.map((url) =>
      fetch(url, {
        headers: gtfsHeaders,
      }).then(async (r) => {
        if (!r.ok) {
          return { valid: false, data: [] };
        }
        return { valid: true, data: await r.json() };
      })
    );
    const responses = await Promise.all(requestPromises);

    const [routes, trips, stops, stopTimes, vehicles] = responses.map(
      (r) => r.data
    );
    return {
      valid: !responses.some((r) => !r.valid),
      data: {
        routes:
          instanceVehicleTypes === INSTANCE_VEHICLE_TYPE_ALL
            ? routes
            : filterRoutesByVehicleTypes(
                routes,
                instanceVehicleTypes.split(',')
              ),
        trips,
        stops,
        stopTimes,
        vehicles,
      },
    };
  } catch (error) {
    console.error(error);
  }
};

export const fetchShapesData = async (shapeId) => {
  const filter = shapeId ? `?shape_id=${shapeId}` : '';
  const shapes = await fetch(`${GTFS_URL}${GTFS_SHAPES_PATH}${filter}`, {
    headers: gtfsHeaders,
  }).then((r) => r.json());

  return shapes;
};

export const fetchVehiclesData = async () => {
  const vehicles = await fetch(`${GTFS_URL}${GTFS_VEHICLES_PATH}`, {
    headers: gtfsHeaders,
  }).then((r) => r.json());

  return vehicles;
};
